import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_shedule } from 'app/idiomas/i18n/shedule/shedule.lang';
import { lang_emailhistory } from 'app/idiomas/i18n/emailhistory/emailhistory.lang';

@Component({
  selector: 'app-email-history-table',
  templateUrl: './email-history-table.component.html',
  styleUrls: ['./email-history-table.component.scss'],
  animations   : fuseAnimations
})
export class EmailHistoryTableComponent implements OnInit {

  menuAbierto = false;
  detallesAbierto = false;
  nameEmpresa= localStorage.getItem('nameEmpresa_HistoryEmail');

  statusMenu: Subject<any> = new Subject<any>();
  productoElegido: Subject<any> = new Subject<any>();

  constructor(
    private location: Location,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    lang_shedule.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_emailhistory.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
  }

  regresar(){
    this.location.back();
  }

}
